import React from "react";
import "./print.scss"

const Print = () => {

    return (
        <div className="print">

        </div>
    )
};

export default Print